<div class="form">
  <div class="heading">
    <h2>Eureka! <span class="header">Register</span></h2>
  </div>
  <form [formGroup]="firstFormGroup">
    <mat-grid-list cols="{{ cols }}" rowHeight="67px">
      <mat-grid-tile>
        <mat-form-field class="input-field">
          <mat-label class="input-label">Full Name</mat-label>
          <input matInput placeholder="Name" formControlName="name" required />
          <mat-error
            *ngIf="firstFormGroup.controls['name'].hasError('required')"
          >
            Name is required!
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field class="input-field">
          <mat-label class="input-label">Email ID</mat-label>
          <input
            matInput
            placeholder="Email"
            name="email"
            pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
            formControlName="email"
            required
          />
          <mat-error
            *ngIf="firstFormGroup.controls['email'].hasError('required')"
          >
            Email is required!
          </mat-error>
          <mat-error *ngIf="firstFormGroup.controls['email'].hasError('email')">
            Email is not Valid!
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field class="input-field">
          <mat-label class="input-label">Gender</mat-label>
          <mat-select formControlName="gender">
            <mat-option *ngFor="let gender of gender" [value]="gender.value">
              {{ gender.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field class="input-field">
          <mat-label class="input-label">Country</mat-label>
          <mat-select formControlName="country">
            <mat-option *ngFor="let country of country" [value]="country.value">
              {{ country.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field class="input-field">
          <mat-label class="input-label">State</mat-label>
          <mat-select formControlName="state">
            <mat-option *ngFor="let state of states" [value]="state.value">
              {{ state.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field class="input-field">
          <mat-label class="input-label">City</mat-label>
          <input matInput placeholder="City" formControlName="city" required />
          <mat-error
            *ngIf="firstFormGroup.controls['city'].hasError('required')"
          >
            City is required!
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field class="input-field">
          <mat-label class="input-label">Country Code (mandatory)</mat-label>
          <input
            matInput
            placeholder="Country Code"
            name="countrycode"
            pattern="[0-9+]{3,4}"
            formControlName="countrycode"
            required
          />
          <mat-error
            *ngIf="firstFormGroup.controls['countrycode'].hasError('required')"
          >
            Country Code is required!
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field class="input-field">
          <mat-label class="input-label">Contact Number</mat-label>
          <input
            maxlength="10"
            matInput
            placeholder="Contact"
            name="contact"
            pattern="[0-9+]{10,10}"
            formControlName="contact"
            required
          />
          <mat-error
            *ngIf="firstFormGroup.controls['contact'].hasError('required')"
          >
            Mobile is required!
          </mat-error>
          <mat-error *ngIf="firstFormGroup.controls['contact'].hasError('min')">
            Mobile No is Wrong!
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field class="input-field">
          <mat-label class="input-label"
            >Current professional status?</mat-label
          >
          <mat-select formControlName="status">
            <mat-option *ngFor="let gender of status" [value]="gender.value">
              {{ gender.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field class="input-field">
          <mat-label class="input-label">Set your team password</mat-label>
          <input
            matInput
            formControlName="password"
            placeholder="Enter your password"
            [type]="hide ? 'password' : 'text'"
            name="password"
          />
          <button
            mat-icon-button
            matSuffix
            (click)="hide = !hide"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide"
          >
            <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
          </button>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field class="input-field">
          <mat-label class="input-label"
            >From where did you hear about Eureka! 2024?*</mat-label
          >
          <mat-select formControlName="source">
            <mat-option *ngFor="let sources of sources" [value]="sources.value">
              {{ sources.viewValue }}
            </mat-option>
          </mat-select> </mat-form-field
        ><br />
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field class="input-field">
          <mat-label class="input-label">Referral ID (If any)</mat-label>
          <input
            matInput
            placeholder="Referral ID"
            formControlName="referral"
          />
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="cols">
        <div>
          <button class="green-button" mat-button (click)="submit()">
            Submit
          </button>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </form>
</div>
